module.exports = __webpack_public_path__ + "img/checklist.0aa55ca7.svg";